// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__S3uAq","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3nIBp","obliqueLine":"membershipbadge_obliqueLine__1TRy3"};